import apiConfig from "@/config/apiConfig";
const rootPath = apiConfig.companyApi; //不带manage

//登录注册
export const basicsEvaluateUsers = {
    saveOrUpdate: rootPath + "/web/basicsEvaluateUsers/saveOrUpdate", // 注册(post)
    checkUser: rootPath + "/web/basicsEvaluateUsers/checkUser", // 登录(get)
    queryCompanyInfo: rootPath + "/web/basicsEvaluateUsers/queryCompanyInfo", // 获取园区企业(get)
    detail: rootPath + "/web/basicsEvaluateUsers/detail", // 详情(get)
}

//获取试题
export const basicsEvaluateInfo = {
  getEvaluateInfo: rootPath + "/web/basicsEvaluateInfo/getEvaluateInfo", // 获取首页信息(get)
  evaluateInfo: rootPath + "/web/basicsEvaluateInfo/evaluateInfo", // 获取试题(get)
}
//测评题目选择题
export const basicsEvaluateOption = {
    listTree:rootPath + "/web/basicsEvaluateOption/selectTreeList",
    list: rootPath + "/web/basicsEvaluateOption/list", // 无分页数据(get)
}

//保存试题
export const basicsEvaluateRecords = {
  saveOrUpdate: rootPath + "/web/basicsEvaluateRecords/saveOrUpdate", // 保存试题(post)
  detail: rootPath + "/web/basicsEvaluateRecords/detail", // 保存试题(post)
  list: rootPath + "/web/basicsEvaluateRecords/list", // 无分页列表(post)
  questionInfo: rootPath + "/web/basicsEvaluateRecords/questionInfo", // 详情(post)
}

//测评结果
export const basicsEvaluateResult = {
  submitEvaluate: rootPath + "/web/basicsEvaluateResult/submitEvaluate", // 提交测评(post)
  getEvaluateResult: rootPath + "/web/basicsEvaluateResult/getEvaluateResult", // 提交测评(post)
  pageList: rootPath + "/web/basicsEvaluateResult/pageList", // 分页(get)
  exportEvaluate: rootPath + "/web/basicsEvaluateResult/exportEvaluate", // 下载报告(get)
  list: rootPath + "/web/basicsEvaluateResult/list", // 无分页列表(get)
  detail: rootPath + "/web/basicsEvaluateResult/detail", // 详情(get)

}
